import { useIsFetching } from '@tanstack/react-query';
import { Loading } from '@pella/react-layout';
import { USE_GLOBAL_LOADING } from '../../../data/constants';

/**
 * A global loading indicator that shows when any react-query queries are fetching.
 */
export const GlobalLoading = () => {
  const isFetching = useIsFetching({
    predicate: (query) => USE_GLOBAL_LOADING.includes(String(query.queryKey[0])),
  });

  return <Loading show={Boolean(isFetching)} />;
};
